import React, { FC, useState, useEffect, useRef, Fragment } from "react";
import "moment/locale/id";
import "./homePage.css";

import signIn from "../../assets/svg/signIn.svg";
import signOut from "../../assets/svg/signOut.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";

interface CheckMenuProps {
  isAbsence: boolean;
}
const CheckMenu: FC<CheckMenuProps> = (props): JSX.Element => {
  const navigate = useNavigate();
  const effectRan = useRef(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [isGetAddress, setIsGetAddress] = useState(false);
  const [userCategory, setuUserCategory] = useState(
    JSON.parse(localStorage.getItem("tokenInfo")).category
  );
  const [attendanceType, setAttendanceType] = useState<any>(
    JSON.parse(localStorage.getItem("companyProfile")).attendanceType
  );
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // if (effectRan.current === false) {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          // getAddress(position.coords.latitude, position.coords.longitude);
        },
        function (error) {
          console.error("Error getting geolocation:", error);
        }
      );
    } else {
      console.log("Geolocation is not available in this browser.");
    }
    // getShiftList();
    effectRan.current = true;
    // }
  }, []);
  return (
    <>
      <Transition appear show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Peringatan
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Anda harus check in terlebih dahulu
                    </p>
                  </div>

                  <div className="mt-4 flex gap-2">
                    <button
                      type="button"
                      className="active:bg-zinc-100 inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                      onClick={() => setOpen(false)}
                    >
                      Tutup
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <div className="flex justify-between mx-8 my-3">
        <div
          onClick={() => {
            attendanceType === "SELFIE"
              ? navigate("/home/selfie-checkin")
              : navigate("/home/shift-choose");
          }}
          className="active:bg-zinc-100 rounded-md border border-transparent bg-white px-5 py-2 text-sm font-medium text-red-900 hover:bg-white-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 flex items-center gap-2"
        >
          <img src={signIn} alt="qr" className="w-5 h-5 text-red-900" />
          <p>Check In</p>
        </div>

        <div
          onClick={() => {
            if (!props.isAbsence) return setOpen(true);

            if (attendanceType === "SELFIE") {
              navigate(
                `/home/shift/map-location/${latitude}/${longitude}/${null}/checkout-selfie`
              );
            } else if (attendanceType === "QR") {
              navigate(
                `/home/shift/map-location/${latitude}/${longitude}/${null}/checkout`
              );
            }
          }}
          className={
            // !props.isAbsence
            // ? "bg-gray-100 rounded-md border border-transparent px-5 py-2 text-sm font-medium text-red-900 hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 flex items-center gap-2"
            "active:bg-zinc-100 rounded-md border border-transparent bg-white px-5 py-2 text-sm font-medium text-red-900 hover:bg-red-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 flex items-center gap-2"
          }
        >
          <img src={signOut} alt="qr" className="w-5 h-5 text-red-900" />
          <p>Check Out</p>
        </div>
      </div>
    </>
  );
};

export default CheckMenu;
